<template>
  <!-- Page Content -->
  <div class="whole-page" id="whole-page-div">
    <AIChatFloat :colorTheme="colorTheme" />
    <div class="navbar-div">
      <NavbarComponent
        :colorTheme="colorTheme"
        :selectedNavLink="selectedNavLink"
        :user="user"
        analysis="MARKETS"
        @eventOnUserSelectNavLink="eventOnClientSelect"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>

    <div class="h-100 d-flex flex-column">
      <!-- Link 1 selected / Currency -->
      <div class="row f-row h-100" v-if="selectedNavLink === 0">
        <div class="col col-12 h-100">
          <Currency :user="user" :colorTheme="colorTheme" />
        </div>
      </div>
      <!-- Link 2 selected / Reports -->
      <div class="row f-row h-100" v-if="selectedNavLink === 1">
        <div class="col col-12 h-100">
          <Commodity :user="user" :colorTheme="colorTheme" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AIChatFloat from "@/components/ai/AIChatFloat.vue";
import Commodity from "@/components/markets/Commodity.vue";
import Currency from "@/components/markets/Currency.vue";
import NavbarComponent from "@/components/Navbar.vue";
import {
  assetSelectionVuex,
  colorThemeChange,
  colorThemeVuex,
} from "@/_core/_helpers/_helpers";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export default {
  name: "markets",
  components: {
    AIChatFloat,
    Commodity,
    Currency,
    NavbarComponent,
  },
  data() {
    return {
      assets: ["currency", "commodity"],
      colorTheme: true, // true = dark, else light
      ignoreVuex: false,
      linkList: ["Currencies", "Commodities"],
      markets_preferences: {},
      root: document.documentElement,
      selectedNavLink: 0,
      user: [],
    };
  },
  watch: {
    "$route.params.productType": {
      immediate: true,
      handler(newProductType) {
        if (newProductType === "currency") {
          this.selectedNavLink = 0;
        } else if (newProductType === "commodity") {
          this.selectedNavLink = 1;
        }
      },
    },
  },
  created() {
    this.ignoreVuex = this.assets.includes(this.$route.params.productType);
    this.markets_preferences = this.$store.state.user_preferences.all.items.markets_choices;
    try {
      this.colorTheme = this.markets_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    if (!this.ignoreVuex) {
      try {
        this.selectedNavLink = this.markets_preferences.selected_nav;
      } catch (error) {
        this.selectedNavLink = 0;
        console.log(`Error nav markets ${error}`);
      }
    }

    // document.title = "Markets | Quanspire";
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.markets_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    eventOnClientSelect(idx) {
      this.selectedNavLink = idx;
      this.markets_preferences.selected_nav = idx;
      assetSelectionVuex(this, this.selectedNavLink);
      this.$store.state.user_preferences.all.items.markets_choices = this.markets_preferences;
      saveUserPreferences(this);
    },
  },
};
</script>
